import { ErrorMessage } from 'formik';
import React from 'react';
import { WithContext as ReactTags } from 'react-tag-input';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { iconForField } from '../../../../common/custom/icon-library';
const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

const StaticOptionExtraSetting = ({
  tags,
  handleTagDelete,
  handleTagAddition,
  getSelectFieldUseAsOption,
  values,
  setFieldValue,
}) => {
  const { extraFieldSetting, isMultiSelect } = values;
  const { staticDefaultValue = [] } = extraFieldSetting;

  const defaultValueOptions = tags.map((el) => ({
    label: el.text,
    value: el.text,
  }));

  const selectValue = isMultiSelect
    ? staticDefaultValue
    : staticDefaultValue && staticDefaultValue.length > 0
    ? staticDefaultValue[0]
    : '';

  const handleSelectChange = (name, selectedValue) => {
    const normalizedValue = Array.isArray(selectedValue)
      ? selectedValue
      : selectedValue !== ''
      ? [selectedValue]
      : [];
    setFieldValue('extraFieldSetting.staticDefaultValue', normalizedValue);
  };

  return (
    <>
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 text-center">
        <CustomInputWithIcon icon="text-placeholder" extraCss="bmd-form-group">
          <ReactTags
            tags={tags}
            delimiters={delimiters}
            handleDelete={handleTagDelete}
            handleAddition={handleTagAddition}
            inputFieldPosition="bottom"
            autoComplete={true}
            placeholder="Add options"
          />
          <div className="row col-12 pl-5">
            <small className="field-detail">
              Press [ Enter ⏎ ] or, [ Comma , ] key to add Options
            </small>
          </div>
          <p className="errors">
            <ErrorMessage name="placeholder.en" />
          </p>
        </CustomInputWithIcon>
      </div>

      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pt-4 text-center">
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-prepend" title="Choose Request Type">
              <span className="input-group-text">
                <i className={`wb ${iconForField('select')}`}></i>
                <span className="required"> *</span>
              </span>
            </div>
            <CustomSelect
              name="staticDefaultValue"
              isMulti={isMultiSelect}
              onChange={setFieldValue}
              onChangeValue={handleSelectChange}
              options={defaultValueOptions}
              value={selectValue}
              placeholder="Select Default Option"
            />
          </div>
        </div>
      </div>

      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pt-3 pl-5">
        {getSelectFieldUseAsOption(values)}
      </div>
    </>
  );
};

export default StaticOptionExtraSetting;
